// extracted by mini-css-extract-plugin
module.exports = {"menuDrawer":"_1F1f-"};